module.exports = __webpack_public_path__ + "img/ff-discount.f6d7080.png";